import { Subject, from, of, interval } from 'rxjs';
import { switchMap, map, delay, delayWhen } from 'rxjs/operators';

export const SubjectRxjs = new Subject(undefined).pipe(
  switchMap(value => from([value, undefined]).pipe(
    delayWhen(value => value ? of(undefined) : interval(5000)),
  )),
);

export const setSnackbar = (value) => { SubjectRxjs.next(value) };